<template>
  <div class="main-content-container container-fluid px-4 bgcontainer">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <!-- <span class="text-uppercase page-subtitle">Overview</span> -->
        <h3 class="page-title">Fichaje de limpiadores:</h3>
        <br />
        <div v-if="loading" class="spinner-border mt-2" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <!-- <d-button type="button" @click="openModal(0,2)" class="btn-accent">Nuevo Usuario</d-button> -->
      </div>
    </div>
    <div class="container">
      <p>{{ dataContrato.direccion1 }}</p>
      <div class="row mt-3">
        <div class="col-md-2"></div>
        <div class="col-md-8">
          <form>
            <div class="form-group row">
              <label for="horario" class="col-sm-3 col-form-label">Contrato:</label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control" id="horario" v-model="dataContrato.contrato_id">
              </div>
            </div>
            <div class="form-group row">
              <label for="dias" class="col-sm-3 col-form-label">Entrada</label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control" id="dias" v-model="dataContrato.entrada">
              </div>
            </div>
            <div class="form-group row">
              <label for="categoria" class="col-sm-3 col-form-label">Salida:</label>
              <div class="col-sm-9">
                <input type="text" readonly class="form-control" id="categoria" v-model="dataContrato.salida">
              </div>
            </div>
            <div class="form-group row">
              <label for="categoria" class="col-sm-3 col-form-label">Comentarios:</label>
              <div class="col-sm-9">
                <textarea type="text" class="form-control" id="categoria" rows="5" cols="5"
                  v-model="dataContrato.comentario" />
              </div>
            </div>
            <div class="form-group row">
              <label for="categoria" class="col-sm-3 col-form-label">Materiales:</label>
              <div class="col-sm-9 text-center">
                <input class="mt-3" type="checkbox" name="" id="" v-model="dataContrato.materiales">
                <!-- <textarea type="text" class="form-control" id="categoria" rows="5" cols="5" /> -->
              </div>
            </div>
            <d-button :disabled="loading" v-if="dataContrato.entrada == '--'" type="button"
              @click="nuevoFichado('Entrada')" class="btn-accent">FICHAR ENTRADA</d-button>
            <d-button :disabled="loading" v-if="dataContrato.entrada != '--' && dataContrato.salida == '--'"
              type="button" @click="nuevoFichado('Salida')" class="btn-accent ml-3">FICHAR SALIDA</d-button>
          </form>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

Vue.use(VueSweetalert2)

import api from "../config/api";
const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};

export default {
  data() {
    return {

      //
      dataContrato: {
        direccion1: '',
        contrato_id: 0,
        entrada: '',
        salida: '',
        comentario: '',
        materiales: ''
      },
      loading: false,
      contrato: null,
      user: null,
      latitud: '',
      longitud: '',
      expe: ''
    };
  },
  async mounted() {
    try {
      this.getCoords();
      this.user = JSON.parse(localStorage.getItem('user'));
      console.log('numero', this.user)
      this.contrato = JSON.parse(localStorage.getItem('controdata'));
      console.log('el contrato vista fichaje', this.contrato)
      this.dataContrato.contrato_id = this.contrato.contro_id
      this.dataContrato.direccion1 = this.contrato.direccion1X
      this.$isLoading(true)
      await this.getFichajeContra()
      this.$isLoading(false)
      //this.items = await this.getUsers();
    } catch (error) {
      console.log('error mounted', error)
    }
  },
  methods: {
    async getCoords() {
      if (navigator.geolocation) {
        let Coordenadas = await navigator.geolocation.getCurrentPosition(await this.showPosition);
        //console.log('coordenadas ', Coordenadas)
        //console.log('###################### COORDENADAS CEL #########################', this.latitud , ' ', this.longitud)
        return 1;
      } else {
        this.$swal('Geolocalización no soportada por navegador.')
        // alert('geolocalización no soportada por navegador.')
        return 0;
      }
    },
    rad(x) {
      return x * Math.PI / 180;
    },
    async getKilometros(lat1, lon1, lat2, lon2) {
      var R = 6378.137; //Radio de la tierra en km
      var dLat = this.rad(lat2 - lat1);
      var dLong = this.rad(lon2 - lon1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.rad(lat1)) * Math.cos(this.rad(lat2)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      d = d * 1000;
      return d.toFixed(3); //Retorna tres decimales
    },
    async getFichajeContra() {
      try {
        this.$isLoading(true);
        let data = {
          contra_id: this.contrato.contra_id,
          contro_id: this.dataContrato.contrato_id,
          usuario_id: 'WB2',
          numero: this.user.numero
        }
        let resultv = await api.request("post", '/verificafichajeContra', data);
        console.log('--', resultv.data)
        this.dataContrato.comentario = resultv.data.justifica
        this.dataContrato.comentario == 'undefined' ? '' : this.dataContrato.comentario;
        this.dataContrato.materiales = resultv.data.materiales == '1' ? true : false;
        console.log('len ', resultv.data.id_diario)
        if (resultv.data.id_diario) {
          try {
            // ABR: 30-08-2021 PERMITIR MAS DE UN FICHAJE
            //verifico si resultv.data >0
            if (resultv.data.fecha_salida == null || resultv.data.fecha_salida == 'null') {
              console.log('cn1')
              this.dataContrato.entrada = resultv.data.fecha_entrada.substr(11, 8)
              this.dataContrato.salida = '--'
              this.$isLoading(false);
            }
            else {
              console.log('cn2')
              this.dataContrato.entrada = '--'
              this.dataContrato.salida = '--'
              this.$isLoading(false);
            }
          } catch (error) {
            console.log('cn3')
            console.log('error', error)
            this.dataContrato.entrada = '--';
            this.$isLoading(false);
          }
          // try {
          //   this.dataContrato.salida = resultv.data.fecha_salida.substr(11,8)
          // } catch (error) {
          //   this.dataContrato.salida = '--';
          //   this.$isLoading(false);
          // }
        }
        else {
          console.log('cn4')
          this.dataContrato.entrada = '--';
          this.dataContrato.salida = '--';
          this.$isLoading(false);
        }
      } catch (error) {
        console.log(error)
        this.$isLoading(false);
      }
    },
    async showPosition(position) {

      this.latitud = '';
      this.longitud = '';
      this.latitud = position.coords.latitude;
      this.longitud = position.coords.longitude;
      console.log(this.latitud, ' ', this.longitud)
    },
    async getCoord() {
      if (navigator.geolocation) {
        let Coordenadas = await navigator.geolocation.getCurrentPosition(await this.showPosition);
        //console.log('coordenadas ', Coordenadas)
        //console.log('###################### COORDENADAS CEL #########################', this.latitud , ' ', this.longitud)
        return 1;
      } else {
        this.$swal('Geolocalización no soportada por navegador.')
        // alert('geolocalización no soportada por navegador.')
        return 0;
      }
    },
    async nuevoFichado(tipo) {
      try {
        let calculoCoordenadas = false;
        //abr 04-08-2021
        //VERIFICA CAMPOS FLEXIBLES
        let informacion = ''
        //SIEMPRE CAPTURO Y ENVIO LAS COORDENADAS PERO POSTERIORMENTE VERIFICO CAMPO FLEXIBLE
        let the = this
        console.log('activando loader1')
        the.$isLoading(true);
        console.log('activando loader2')
        const getCoords = async () => {
          const pos = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
          });

          return {
            long: pos.coords.longitude,
            lat: pos.coords.latitude,
          };
        };

        const coords = await getCoords();
        console.log('coordenadas--> ', coords)
        // the.loading = false;
        console.log('...', coords.lat)

        console.log('ok')
        the.latitud = Number(coords.lat);
        the.longitud = Number(coords.long);

        let coordenadasContra = the.contrato.google.toString();
        coordenadasContra = the.contrato.google.split(",");
        console.log('contrato coordenadas', this.contrato)
        let lt = String(coordenadasContra[0]).replace("'", "", 'g')
        let lng = String(coordenadasContra[1]).replace("'", "", 'g')
        console.log('coodenadas contra', lt, lng)

        the.distancia = await the.getKilometros(Number(the.latitud), Number(the.longitud), Number(lt), Number(lng));
        console.log('distancia entre coordenadas', the.distancia)

        if (the.contrato.flexible_total == 1 || the.contrato.flexible_coordenadas == 1 || the.contrato.flexible_dias == 1) {
          calculoCoordenadas = true;
          console.log('flexible total o coordenadas')
          if (the.contrato.flexible_total == 1)
            informacion = 'flexible total.'
          if (the.contrato.flexible_coordenadas == 1)
            informacion = 'flexible coordenadas.'
          informacion = informacion + ' / Su distancia es : ' + the.distancia + " mts." + the.expe
        }
        else {
          try {
            console.log('no flexible', the.distancia)
            if (the.contrato.google.trim() == '' || the.contrato.google == null) {
              console.log('cd0')
              the.$isLoading(false);
              the.$swal('Error, contrata sin coordenadas.')
              calculoCoordenadas = false;
              return;
            }
            else {

              if (the.distancia > 800) {
                console.log('cd1')
                the.$isLoading(false);
                the.$swal('Error, no está en el rango permitido.')
                calculoCoordenadas = false;
                return;
              }
              else {
                console.log('cd2')
                //the.$isLoading(false);
                informacion = 'Está en el rango para marcar, su distancia es : ' + the.distancia + " mts." + the.expe
                calculoCoordenadas = true;
              }
            }
          } catch (error) {
            console.log('cd3')
            console.log('error calculo distancia', error)
            the.$isLoading(false);
            the.$swal('Error en calculo distancia.')
            calculoCoordenadas = false;
            return;
          }
        }

        if (calculoCoordenadas == true) {
          console.log('cd4')
          let horario = the.contrato.horario
          console.log('horario', horario)
          let horariotmp1 = horario.substr(0, 2)
          let horariotmp2 = horario.substr(2, 2)
          horario = horariotmp1 + ":" + horariotmp2
          let diassemana = the.contrato.diassemana[0].trim()
          let horasdia = the.contrato.horas_dia
          let datav = {
            dias: diassemana,
            horariotmp: horario,
            horasdia: horasdia,
            contra_id: the.contrato.contra_id,
            contro_id: the.contrato.contro_id,
            numero: the.user.numero,
            informacion: informacion,
            justifica: the.dataContrato.comentario == 'undefined' || the.dataContrato.comentario == undefined ? '' : the.dataContrato.comentario,
            ubicacion: await the.latitud + " , " + await the.longitud,
            expe: the.expe,
            contra_id: the.contrato.contra_id,
            usuario_id: 'WB2',
            flexible_total: the.contrato.flexible_total,
            materiales: the.dataContrato.materiales == true ? '1' : '0'
          }
          console.log('datav', datav)
          let res = await api.request("post", "/nuevoFichajeApp/", datav)
          console.log('respuesta---->',res)
          //.then(async resp => {
          await the.getFichajeContra()

          console.log('***####################################*****');
          // console.log('-----', resp.data)
          the.$swal('Ha fichado correctamente.')
          the.$isLoading(false);

          if (tipo == 'Salida') {
            the.$router.push('/Contratosv2/'+this.user.numero)
          }
          // }).catch(error => {
          //   the.$isLoading(false);
          //   the.$swal(`Error, intentalo nuevamente(${error}).`)
          //   console.log(error)
          // })
        }
        else {
          the.$isLoading(false);
          console.log('cd5')
          console.log('no ficho por algun motivo')
        }
        // no
      } catch (error) {
        this.$isLoading(false);
        this.$swal(`Error, intentalo nuevamente(${error}).`)
        console.log('error', error)
      }
    },
  },
};
</script>

<style></style>